var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDecor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 32,
  viewBox: "0 0 20 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 19,
  height: 31,
  rx: 3.5,
  stroke: "url(#decor_svg__paint0_linear_3606_7609)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "decor_svg__paint0_linear_3606_7609",
  x1: 10,
  y1: 0,
  x2: 10,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBB00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.411458,
  stopColor: "#7A5401"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFBB00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A88616"
})))));
export { SvgDecor as ReactComponent };
export default __webpack_public_path__ + "assets/icons/decor.7a84d3.svg";